'use strict'

/**
 * Composant Progressbar
 */

export default Vue.component('progressbar', {
    props: ['pourcentage', 'montant', 'libelle'],
    computed: {
        width() {
            return this.pourcentage + '%'
        }
    }
})
